var map = {
	"./ArsredovisningOnline-logo.png": "db01",
	"./Crona-logo.png": "c91c",
	"./FrejaPartner.png": "dedb",
	"./Inexchange-logo.png": "3bbc",
	"./NVR-logo.png": "f6d4",
	"./Trinax-logo.png": "727e",
	"./ansvarsfullt.se.png": "2aa7",
	"./prispartner-logo.png": "1549"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fdfe";